import React, { Component } from "react";
import { connect } from "react-redux";
import format from "date-fns/format";
import { DIMENSIONS } from "services/layoutManager";
import BloxPage from "sub_components/Layout/BloxPage";
import ComponentWrapper from "sub_components/Layout/ComponentWrapper";
import { RESOLUTIONS } from "services/config";
import LoadingCube from "sub_components/Common/LoadingCube";
import { Filter } from "styled_components/Common/Filter";
import { Sort } from "styled_components/Common/Sort";
import { SortProvider } from "context/SortContext";
import { FilterProvider } from "context/FilterContext";
import { PortraitModalComponent } from "styled_components/Common/PortraitModalComponent";
import { MENU, INVOICE_SUMMARY_HEADERS } from "utils/BillingConstants";
import { BillingApi, BillingUtils, FILTERS } from "services/billing";
import { ListComponent } from "styled_components/Account/ListComponent";
import { SITE_PAGES, SITE_MODULES } from "utils/CommonConstants";
import {
  updatePage,
  updateModule,
  addPageToBreadCrumbs,
} from "actions/siteTracking";
import { Permissions } from "services/permissions";
import DisplayBill from "sub_components/Billing/DisplayBill";
import { SORT_OPTIONS } from "services/billing";
import { updatePermissions } from "actions/permissions";
import { getUserPermissions, setUserPermissions } from "services/user";
import InvoiceDetailPage from "./InvoiceDetailPage";

const Invoice_Sort = [
  { displayValue: "All", value: 0 },
  { displayValue: "Sent Date - ASC", value: 1 },
  { displayValue: "Sent Date - DESC", value: 2 },
  { displayValue: "Due Date - ASC", value: 3 },
  { displayValue: "Due Date - DESC", value: 4 },
  { displayValue: "Invoice # - ASC", value: 5 },
  { displayValue: "Invoice # - DESC", value: 6 },
];

const LAYOUT_CONFIG = {
  [RESOLUTIONS.LOW]: {
    invoiceHistory: { x: 0, y: 1, dim: DIMENSIONS.EIGHT_BY_TEN },
  },
  [RESOLUTIONS.MED]: {
    invoiceHistory: { x: 0, y: 1, dim: DIMENSIONS.EIGHT_BY_TEN },
  },
  [RESOLUTIONS.HIGH]: {
    invoiceHistory: { x: 0, y: 1, dim: DIMENSIONS.EIGHT_BY_TEN },
  },
};

class InvoiceHistoryPage extends Component {
  constructor(props) {
    super(props);
    this.billingApi = new BillingApi();
    this.state = {
      filteredData: "",
      currentMonth: "",
      prev3Months: "",
      currentSortSelected: SORT_OPTIONS.INVOICE_DATE_DESC,
      currentfilterSelected: FILTERS.ALL,
      data: null,
      supportSectionComponent: null,
      filteredAndSortedData: null,
      pages: null,
      loading: true,
      showModal: false,
      invoiceId: null,
      invoiceNumber: null,
      invoiceSelected: null,
      transactionsLoading: false,
      listData: null,
      intacct: false,
      selectedInvoice: null,
    };
  }
  componentDidMount() {
    const {
      updatePage,
      updateModule,
      addPageToBreadCrumbs,
      company_info: { customer: { id } } = {},
      site,
      permissions,
    } = this.props;
    this.checkForInvoiceId();
    updatePage(SITE_PAGES.BILLING[MENU.HISTORY]);
    addPageToBreadCrumbs(
      SITE_PAGES.BILLING[MENU.HISTORY],
      SITE_MODULES.BILLING
    );
    if (site?.module !== "BILLING" || !permissions?.permissions) {
      this.getModulePages();
    }

    updateModule(SITE_MODULES.BILLING);
    this.checkForInvoices(id);
  }
  componentDidUpdate(prevProps) {
    const previousCompanyId = prevProps?.company_info?.customer?.id;
    const { company_info: { customer: { id } } = {} } = this.props;

    if (previousCompanyId !== id) {
      this.requestInvoices(id);
    }

    this.checkForInvoiceId();
  }

  checkForInvoices = (id) => {
    const storedInvoices = sessionStorage.getItem("invoices");
    const massagedData = JSON.parse(storedInvoices);
    if (storedInvoices && massagedData?.length !== 0) {
      this.processInvoices(massagedData);
    } else {
      if (id) {
        this.requestInvoices(id);
      }
    }
  };
  processInvoices = (massagedData) => {
    const { currentfilterSelected, currentSortSelected } = this.state;
    const {
      //permissions: pages,
      location,
      //company_info: { customer: { customerId = 0 } } = {},
    } = this.props;
    // const ViewInvoiceDetails = Permissions.checkComponentAccess(
    //   pages,
    //   "Current Invoices",
    //   "view-invoice-details"
    // );
    const filteredData = BillingUtils.filterList2(
      massagedData,
      currentfilterSelected
    );
    const filteredAndSortedData = BillingUtils.billingSort2(
      filteredData,
      currentSortSelected
    );

    this.setState(
      {
        data: massagedData,
        filteredAndSortedData,
        loading: false,
        invoiceSelected: location?.state?.invoiceNumber,
      },
      () => this.setData(filteredAndSortedData, true)
    );
  };

  checkForInvoiceId = () => {
    const { selectedInvoice } = this.state;
    const { pathname } = window.location;
    const matches = pathname.split("/");

    if (matches) {
      const [, , , , invoiceId] = matches;

      if (invoiceId !== undefined && selectedInvoice !== invoiceId) {
        this.setState({ selectedInvoice: invoiceId });
      } else if (invoiceId === undefined && selectedInvoice !== null) {
        this.setState({ selectedInvoice: null });
      }
    }
  };

  getModulePages = async () => {
    const {
      updatePermissions,
      auth_status: {
        user: { id: userId },
      },
      company_info: {
        customer: { id: orgId },
      },
    } = this.props;

    const permissions = getUserPermissions("billing");
    if (!permissions) {
      const response = await Permissions.getModulePermissions(4, userId, orgId);
      if (response && !response.data.error) {
        setUserPermissions("billing", response.data.pages);
        updatePermissions(response.data.pages);
      }
    } else {
      updatePermissions(permissions);
    }
  };
  handleInvoiceRetrievalError = (error) => {
    const { modal } = this.refs;

    if (modal) {
      if (!modal.classList.contains("fail")) {
        modal.classList.add("fail");
        setTimeout(() => {
          modal.classList.remove("fail");
        }, 3000);
      }
    }

    this.setState({ error });
  };
  updateData = (formattedTransactions, invoiceNumber) => {
    const { listData } = this.state;
    const componentIndex = listData.findIndex(
      (item) => Number(item?.id) === Number(invoiceNumber)
    );
    this.setState(
      // eslint-disable-next-line
      (state) =>
        // eslint-disable-next-line
        (state.listData[componentIndex].expandedValues = formattedTransactions)
    );
  };

  massageInvoices = (response) => {
    let massagedData = [];
    let invoiceData = [];
    const { invoices = [], intacctInvoices = [] } = response;
    if (intacctInvoices && intacctInvoices.length !== 0) {
      this.setState({ intacct: true });
      const formattedInvoices =
        BillingUtils.formatIntacctInvoice(intacctInvoices);

      massagedData = BillingUtils.massageData(
        formattedInvoices,
        INVOICE_SUMMARY_HEADERS
      );
    }
    if (invoices && invoices.length !== 0) {
      invoiceData = BillingUtils.massageData(invoices, INVOICE_SUMMARY_HEADERS);
    }

    return [...massagedData, ...invoiceData];
  };

  requestInvoices = () => {
    const { company_info: { customer: { id, customerId } } = {} } = this.props;
    this.billingApi
      .getAll(id, null, customerId)
      .then((response) => {
        if (response.status !== 200 || response.data.error) {
          this.handleInvoiceRetrievalError(response.data.error || "Error");
        } else {
          const massagedData = this.massageInvoices(response?.data);
          sessionStorage.setItem("invoices", JSON.stringify(massagedData));
          this.processInvoices(massagedData);
        }
      })
      .catch((e) => {
        console.log(e);
        this.setState({ loading: false });
        this.handleInvoiceRetrievalError("Network error");
      });
  };

  sortInvoices = (selected) => {
    const { permissions: pages } = this.props;
    const ViewInvoiceDetails = Permissions.checkComponentAccess(
      pages,
      "Current Invoices",
      "view-invoice-details"
    );
    const { currentfilterSelected, data } = this.state;
    const filteredData = BillingUtils.filterList2(data, currentfilterSelected);
    const filteredAndSortedData = BillingUtils.billingSort2(
      filteredData,
      selected
    );

    this.setState(
      { currentSortSelected: selected, filteredAndSortedData },
      () => {
        this.setData(filteredAndSortedData, ViewInvoiceDetails);
      }
    );
  };

  filterInvoices = (selected) => {
    const { permissions: pages } = this.props;
    const ViewInvoiceDetails = Permissions.checkComponentAccess(
      pages,
      "Current Invoices",
      "view-invoice-details"
    );
    const { currentSortSelected, data } = this.state;
    const filteredData = BillingUtils.filterList2(data, selected);
    const filteredAndSortedData = BillingUtils.billingSort2(
      filteredData,
      currentSortSelected
    );

    this.setState(
      { currentfilterSelected: selected, filteredAndSortedData },
      () => this.setData(filteredAndSortedData, ViewInvoiceDetails)
    );
  };

  checkViewPermissions = (data) => {
    const { permissions: pages } = this.props;
    let viewableInvoices = data;
    const ViewUnpaidInvoices = Permissions.checkComponentAccess(
      pages,
      "Invoice History",
      "view-invoices-unpaid"
    );
    const ViewPaidInvoices = Permissions.checkComponentAccess(
      pages,
      "Invoice History",
      "view-invoices-paid"
    );
    viewableInvoices = ViewPaidInvoices
      ? viewableInvoices
      : viewableInvoices.filter(
          (invoice) => invoice.status.toLowerCase() !== "paid"
        );
    viewableInvoices = ViewUnpaidInvoices
      ? viewableInvoices
      : viewableInvoices.filter(
          (invoice) =>
            invoice.status.toLowerCase() !== "due" &&
            invoice.status.toLowerCase() !== "overdue"
        );

    return viewableInvoices;
  };

  downloadPdf = (invoiceId, type, invoiceDocID) => {
    const { company_info: { customer: { id } } = {} } = this.props;
    const invoiceID = type === "intacct" ? invoiceDocID : invoiceId;
    this.billingApi
      .get(invoiceID, id, type)
      .then((response) => {
        this.setState({ pdfFile: response.data.file });

        this.billingApi.downloadPdf(response.data.file, invoiceId);
      })
      .catch((error) => this.setState({ error }));
  };

  getHeaders = () => {
    return [
      { label: "Invoice", size: "sm" },
      { label: "Sent", size: "sm" },
      { label: "Total", size: "sm" },
      { label: "Due", size: "sm" },
      { label: "Balance", size: "sm" },
      { label: "Status", size: "sm" },
    ];
  };
  getSize = (breakpoint) => {
    let size = "large";
    if (breakpoint === RESOLUTIONS.MED) {
      size = "large";
    } else if (breakpoint === RESOLUTIONS.HIGH) {
      size = "large";
    }

    return size;
  };
  toggleModal = (id, number) => {
    const { showModal } = this.state;
    if (showModal) {
      this.setState({
        showModal: !showModal,
        invoiceId: null,
        invoiceNumber: null,
      });
    } else {
      this.setState({
        showModal: !showModal,
        invoiceId: id,
        invoiceNumber: number,
      });
    }
  };
  getTransactionType = (type) => {
    let transactionType = null;
    const typeLower = type ? type.toLowerCase() : "";

    if (
      typeLower === "payment" ||
      typeLower === "credit" ||
      typeLower === "credit card" ||
      typeLower === "deffered discount" ||
      typeLower === "reverse charge" ||
      typeLower === "reverse charge earned" ||
      typeLower === "write off"
    ) {
      transactionType = "debit";
    } else if (typeLower === "charge" || typeLower === "purchase") {
      transactionType = "credit";
    }

    return transactionType;
  };
  setInvoice = (invoice) => {
    const { navigate } = this.props;
    navigate(`/portal/billing/invoice_history/${invoice?.invoiceId}`, {
      state: { invoice },
    });
  };
  setData = (filteredAndSortedData, ViewInvoiceDetails) => {
    const filteredData =
      filteredAndSortedData && this.checkViewPermissions(filteredAndSortedData);
    const formattedInvoices = [];

    filteredData &&
      filteredData.forEach((invoice) => {
        const sent = format(new Date(invoice?.billcycle), "MM.dd.yy");
        const transactions = invoice?.transactions;
        const formattedTransactions = [];
        transactions.forEach((transaction) => {
          const amount = transaction?.amount;

          const transactionType = this.getTransactionType(
            transaction?.transactionType
          );
          formattedTransactions.push({
            one: { value: transaction?.effectiveDate, size: "sm" },
            two: { value: transaction?.description, size: "lg" },
            three: {
              value: amount && String(amount).includes("$") ? String(amount).replace("$", "") : "",
              size: "sm",
              amount: true,
              type: transactionType,
            },
          });
        });

        formattedInvoices.push({
          startDate: invoice?.startDate,
          id: invoice?.invoiceId,
          docId: invoice?.docId,
          soRecordNo: invoice?.soRecordNo,
          key: invoice?.invoice_number,
          onClick: () => this.setInvoice(invoice),
          type: invoice?.type,
          values: [
            { label: invoice?.invoice_number, size: "sm" },
            { label: sent, size: "sm" },
            { label: invoice?.amount, size: "sm" },
            { label: invoice?.dueDate, size: "sm" },
            { label: invoice?.amount_due, size: "sm" },
            { label: invoice?.status, size: "sm" },
          ],
          expandedHeaders: [
            { label: "Date", size: "sm" },
            { label: "Description", size: "lg" },
            { label: "Amount", size: "sm" },
          ],
          expandedSize: "lg",
          expandedValues: formattedTransactions,
          button1: ViewInvoiceDetails
            ? { text: "Download", onClick: this.downloadPdf }
            : null,
          button2: ViewInvoiceDetails
            ? { text: "View", onClick: this.toggleModal }
            : null,
        });
      });

    this.setState({ listData: formattedInvoices });
  };
  updateFilterSelected = (selected) => {
    this.filterInvoices(selected);
  };
  updateSortSelected = (selected) => {
    this.sortInvoices(selected?.displayValue);
  };
  render() {
    const billingHistoryFiltering = [
      FILTERS.ALL,
      FILTERS.CURRENT,
      FILTERS.LAST3,
      FILTERS.PAID,
      FILTERS.UNPAID,
    ];

    const {
      loading,
      showModal,
      invoiceId,
      invoiceNumber,
      currentfilterSelected,
      transactionsLoading,
      listData,
      intacct,
      data,
      selectedInvoice,
      filteredAndSortedData,
    } = this.state;

    const {
      breakpoint,
      company_info: { customer: { id } } = {},
      invoiceSelected,
      location,
      navigate,
    } = this.props;

    return !selectedInvoice ? (
      <BloxPage
        name="page invoice-history-page"
        layout={LAYOUT_CONFIG[breakpoint]}
        breakpoint={breakpoint}
        location={location}
      >
        <div key={`invoiceHistory`} className="invoiceHistory">
          <ComponentWrapper title="Search Results" hideBorder>
            {!loading && (
              <FilterProvider>
                <SortProvider>
                  <ListComponent
                    headers={this.getHeaders()}
                    data={listData}
                    module="billing"
                    selected={invoiceSelected}
                    location={location}
                    intacct={intacct}
                    loading={transactionsLoading}
                  >
                    <Filter
                      module="billing"
                      selected={currentfilterSelected}
                      options={billingHistoryFiltering}
                      callback={this.updateFilterSelected}
                      filterHeading="Filter By"
                    />
                    <Sort
                      module="billing"
                      selected={{ displayValue: "All", value: 0 }}
                      options={Invoice_Sort}
                      callback={this.updateSortSelected}
                      filterHeading="Sort By"
                    />
                  </ListComponent>
                </SortProvider>
              </FilterProvider>
            )}

            {loading && <LoadingCube />}
          </ComponentWrapper>
        </div>
      </BloxPage>
    ) : (
      <>
        <InvoiceDetailPage
          navigate={navigate}
          breakpoint={breakpoint}
          location={location}
          downloadPdf={this.downloadPdf}
          viewInvoice={this.toggleModal}
          invoices={filteredAndSortedData}
          requestInvoices={this.requestInvoices}
          invoicesLoading={loading}
        />
        <PortraitModalComponent
          closeModal={this.toggleModal}
          show={showModal}
          title={`Invoice ${invoiceNumber}`}
          subTitle={null}
          size={this.getSize(breakpoint)}
          customClassName="showOverflow"
          breakpoint={breakpoint}
        >
          <DisplayBill
            supportParams={{
              invoiceId,
              invoiceNumber,
              downloadPdf: this.downloadPdf,
            }}
            orgId={id}
            breakpoint={breakpoint}
            data={data}
          />
        </PortraitModalComponent>
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    auth_status: state.auth_status,
    company_info: state.company_info,
    site: state.site_tracking,
    permissions: state.permissions,
  };
}
export default connect(mapStateToProps, {
  updatePage,
  updateModule,
  addPageToBreadCrumbs,
  updatePermissions,
})(InvoiceHistoryPage);
